var _circle, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#234596"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0029 6.97266C9.22453 6.97266 6.97168 9.22551 6.97168 12.0039C6.97168 14.7823 9.22453 17.0352 12.0029 17.0352C14.7813 17.0352 17.0342 14.7823 17.0342 12.0039C17.0342 9.22551 14.7813 6.97266 12.0029 6.97266Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2373 11.2383H12.1123V14.4102",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9092 14.5195H13.3154",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0029 8.77734C11.8623 8.77734 11.7249 8.81904 11.608 8.89716C11.491 8.97528 11.3999 9.08631 11.3461 9.21622C11.2923 9.34612 11.2782 9.48907 11.3057 9.62698C11.3331 9.76489 11.4008 9.89156 11.5002 9.99099C11.5996 10.0904 11.7263 10.1581 11.8642 10.1856C12.0021 10.213 12.1451 10.1989 12.275 10.1451C12.4049 10.0913 12.5159 10.0002 12.5941 9.88326C12.6722 9.76634 12.7139 9.62889 12.7139 9.48828C12.7139 9.29973 12.639 9.1189 12.5056 8.98557C12.3723 8.85225 12.1915 8.77734 12.0029 8.77734Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiIGZpbGw9IiMyMzQ1OTYiLz4KPHBhdGggZD0iTTEyLjAwMjkgNi45NzI2NkM5LjIyNDUzIDYuOTcyNjYgNi45NzE2OCA5LjIyNTUxIDYuOTcxNjggMTIuMDAzOUM2Ljk3MTY4IDE0Ljc4MjMgOS4yMjQ1MyAxNy4wMzUyIDEyLjAwMjkgMTcuMDM1MkMxNC43ODEzIDE3LjAzNTIgMTcuMDM0MiAxNC43ODIzIDE3LjAzNDIgMTIuMDAzOUMxNy4wMzQyIDkuMjI1NTEgMTQuNzgxMyA2Ljk3MjY2IDEyLjAwMjkgNi45NzI2NloiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz4KPHBhdGggZD0iTTExLjIzNzMgMTEuMjM4M0gxMi4xMTIzVjE0LjQxMDIiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEwLjkwOTIgMTQuNTE5NUgxMy4zMTU0IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTEyLjAwMjkgOC43NzczNEMxMS44NjIzIDguNzc3MzQgMTEuNzI0OSA4LjgxOTA0IDExLjYwOCA4Ljg5NzE2QzExLjQ5MSA4Ljk3NTI4IDExLjM5OTkgOS4wODYzMSAxMS4zNDYxIDkuMjE2MjJDMTEuMjkyMyA5LjM0NjEyIDExLjI3ODIgOS40ODkwNyAxMS4zMDU3IDkuNjI2OThDMTEuMzMzMSA5Ljc2NDg5IDExLjQwMDggOS44OTE1NiAxMS41MDAyIDkuOTkwOTlDMTEuNTk5NiAxMC4wOTA0IDExLjcyNjMgMTAuMTU4MSAxMS44NjQyIDEwLjE4NTZDMTIuMDAyMSAxMC4yMTMgMTIuMTQ1MSAxMC4xOTg5IDEyLjI3NSAxMC4xNDUxQzEyLjQwNDkgMTAuMDkxMyAxMi41MTU5IDEwLjAwMDIgMTIuNTk0MSA5Ljg4MzI2QzEyLjY3MjIgOS43NjYzNCAxMi43MTM5IDkuNjI4ODkgMTIuNzEzOSA5LjQ4ODI4QzEyLjcxMzkgOS4yOTk3MyAxMi42MzkgOS4xMTg5IDEyLjUwNTYgOC45ODU1N0MxMi4zNzIzIDguODUyMjUgMTIuMTkxNSA4Ljc3NzM0IDEyLjAwMjkgOC43NzczNFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };